module.exports = {
  mounted() {
    this.checkVersion()
      .then((versionObj) => {
        if (this.$t("appVersion") !== versionObj.version) {
          console.log(
            "appVersions: ",
            this.$t("appVersion"),
            versionObj.version
          );
          /* this.$eBus.$emit('app-shell-update') */
        }
      })
      .catch((err) => {
        console.error(err);
      });

    if (navigator.serviceWorker) {
      navigator.serviceWorker
        .getRegistration()
        .then((reg) => {
          if (reg != undefined) {
            reg.update().then((el) => console.log("update complete", el));
          }
        })
        .catch((e) => console.log(e));
    }
  },
};
